import { BRAND_LIST, CountryLanguageSwitcher, Languages } from 'typings'
import * as Typings from '../typings'

const DenmarkLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'dk',

  LONG_NAME: 'Denmark',
  SHORT_NAME: 'DK',

  DISPLAY_COUNTRY: 'Denmark',

  LANGUAGES: {
    EN: 'en', // The first language in this object is the default language for fallback redirect. For 26.10.0, make sure it's still EN
    DA: 'da',
  },

  [BRAND_LIST.UQ]: {
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Denmark (English)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/dk/en/',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/dk/en/',
      CONTACT_US_URL: 'https://faq-dk.uniqlo.com/',
      TERMS_OF_USE_URL:
        'https://faq-dk.uniqlo.com/pkb_Home_UQ_DK?id=kA0Vh0000001Mct&l=en_US',
      PRIVACY_POLICY_URL:
        'https://faq-dk.uniqlo.com/pkb_Home_UQ_DK?id=kA0Vh0000001Mmq&l=en_US',
    },
    [Languages.DA]: {
      LANGUAGE_CODE: 'da',
      DISPLAY_NAME: 'Denmark (Dansk)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/dk/da/',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/dk/da/',
      CONTACT_US_URL: 'https://faq-dk.uniqlo.com/pkb_Home_UQ_DK?l=da',
      TERMS_OF_USE_URL:
        'https://faq-dk.uniqlo.com/pkb_Home_UQ_DK?id=kA0Vh0000001Mct&l=da',
      PRIVACY_POLICY_URL:
        'https://faq-dk.uniqlo.com/pkb_Home_UQ_DK?id=kA0Vh0000001Mmq&l=da',
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 56.2050544,
    INITIAL_LONGITUDE: 8.9041622,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Hovedstaden',
    '2': 'Midtjylland',
    '3': 'Nordjylland',
    '4': 'Sjælland',
    '5': 'Syddanmark',
  },

  MAP_URL: 'https://www.uniqlo.com/dk/en/content/store-locator.html',

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },
  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default DenmarkLocale
